import { type ReactElement, useEffect } from 'react';
import { useBlocker } from 'react-router';
import { Button } from '@/shared/ui';

/** 미저장 사진 또는 전송이 있을 때만 마운트한다. 브라우저 이탈과 SPA 이동을 함께 다룬다. */
export const PhotoDraftLeaveGuard = (): ReactElement => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => currentLocation.pathname !== nextLocation.pathname,
  );
  useEffect(() => {
    const beforeUnload = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', beforeUnload);
    return () => window.removeEventListener('beforeunload', beforeUnload);
  }, []);
  return (
    <div className="space-y-2 rounded border border-amber-500 p-3 text-sm">
      <p>
        미저장 사진 편집이 있습니다. 새로고침하거나 화면을 나가면 사진 편집 상태가 사라집니다.
        업로드한 파일은 보관됩니다.
      </p>
      {blocker.state === 'blocked' ? (
        <div role="alertdialog" aria-label="미저장 사진 편집 안내" className="space-y-2">
          <p>사진 편집을 버리고 다른 화면으로 이동하시겠습니까?</p>
          <div className="flex gap-2">
            <Button type="button" onClick={() => blocker.reset()}>
              계속 편집
            </Button>
            <Button type="button" variant="outline" onClick={() => blocker.proceed()}>
              편집을 버리고 이동
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};
